import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const Loader = props => {
    const { t } = useTranslation();

    const wrapperClasses = classNames({
        'loader-wrapper': true,
        'loader-wrapper--inline': props.inline,
        'loader-wrapper--large': props.large
    }, props.additionalClass);

    const loaderClasses = classNames('loader', {
        'loader--spinner': props.spinner,
        'loader--dotted': props.dotted
    });

    return (
        <div className={wrapperClasses}>
            <div className={loaderClasses}>
                <span className="sr-only">{t('ui.loader.text')}</span>
            </div>
        </div >
    );
};

export default Loader;
